import { cx } from '@libs/classnames';
import styles from './MainSection.module.css';
import { LandingSection } from '@features/landing/shared/ui/components/LandingSection';
import { MainBgOverlay } from '@features/landing/shared/ui/icons/MainBgOverlay';
import { ReactNode } from 'react';

export type MainSectionProps = {
  className?: string;
  title: ReactNode;
  subtitle?: ReactNode;
  details?: ReactNode;
};

export function MainSection({
  className,
  title,
  subtitle,
  details,
}: MainSectionProps) {
  return (
    <LandingSection className={cx(styles.root, className)}>
      <MainBgOverlay className={styles.overlay} />

      <div className={styles.content}>
        <div className={styles.logos}>
          <div className={styles.federationLogo}>
            <img
              src="/images/landing/federation-logo.svg"
              alt="Федерация Шахмат России"
            />
          </div>
          <div className={styles.schoolLogo}>
            <img
              src="/images/landing/school-logo.svg"
              alt="Русская Шахматная Школа"
            />
          </div>
        </div>

        <h1 className={styles.title}>{title}</h1>

        {subtitle && <h2 className={styles.subtitle}>{subtitle}</h2>}

        {details && <div className={styles.details}>{details}</div>}
      </div>
    </LandingSection>
  );
}
